import { Component, OnDestroy } from '@angular/core';
import { StateService } from '@app/core/services/state.service';
import { PurchHeadGetParams, PurchHeadService } from '@app/services/purch-head.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'tt-purch-head-view',
    templateUrl: './purch-head-view.component.html',
    styleUrls: ['./purch-head-view.component.css'],
})
export class PurchHeadViewComponent implements OnDestroy {
    private subscription: Subscription;
    constructor(private state: StateService, public purchheadservice: PurchHeadService) {
        console.log(state.getStateParams());
        this.purchheadservice.setPurchHeadFromParams(state.getStateParams() as unknown as PurchHeadGetParams);

        this.subscription = this.purchheadservice.currentPurchHead$.subscribe({
            next: (get) => {
                if (!!get) {
                    this.state.setTitleOverride(get?.purch_heading);
                }
            },
        });
    }

    public onSubmit(event: 'save' | 'delete') {
        if (event === 'delete') {
            this.state.back();
        }
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
        this.purchheadservice.setPurchHeadFromParams(null);
    }
}
